export default function authHeader() {
  let user = localStorage.getItem('i_user') || localStorage.getItem('user')
  if (user) {
    return `Token ${user}`
  } else {
    return ''
  }
}
